import uiRouter from '@uirouter/angularjs';

import { ImageLibraryModule } from 'components/imageLibrary/imageLibrary.module';
import { NativePlatformServiceModule } from 'services/access/nativePlatform/nativePlatform.service';
import { MenuEditorService } from '../menuEditor/menuEditor.service';

import template from './redactor.html';
import './redactor.scss';

export const RedactorDirectiveModule = angular
    .module('app.components.redactor.redactorDirective', [
        'ngMaterial',
        uiRouter,
        ImageLibraryModule,
        MenuEditorService,
        NativePlatformServiceModule
    ]).directive('redactor', (
        $timeout,
        $mdDialog,
        imageLibraryService,
        menuEditorService,
        nativePlatformService,
        $state,
        $window
    ) => {
        return {
            require: 'ngModel',
            restrict: 'E',
            template,
            replace: true,
            scope: {},
            link: (scope, elem, attrs, ngModel) => {
                let $editor = angular.element('.redactor__scope');
                let el;
                let showExpand = !!attrs.expand;
                scope.count = 0;
                scope.MAX = parseInt(attrs.maxlength);
                scope.updateModel = updateModel;

                let plugins = [
                    'source',
                    'addlink',
                    'addimage',
                    'addvideo',
                    'expand',
                    'charactercounter',
                    'bufferbuttons'
                ];

                if (!showExpand) {
                    plugins = plugins.filter(plugin => plugin !== 'expand');
                }

                $timeout(() => {
                    el = angular.element(elem).find('textarea');
                    if (!nativePlatformService.isIOS) {
                        el.redactor({
                            minHeight: 320,
                            maxHeight: 320,
                            buttons: ['source', 'format', 'style', 'bold', 'italic', 'lists'],
                            plugins,
                            cleanOnPaste: true,
                            pastePlainText: true,
                            toolbarFixed: false,

                            // eslint-disable-next-line object-shorthand
                            callbacks: {
                                change() {
                                    if (!scope.initialLoad) {
                                        updateModel(this.code.get());
                                    }
                                    scope.initialLoad = false;
                                }
                            },
                            deniedTags: ['script', 'code', 'embed']//,
                            // paragraphize: true
                        });
                    } else {
                        scope.fallbackTextValue = ngModel.$modelValue;
                    }
                });

                function updateModel(val) {
                    let $counterButton = angular.element('.redactor-toolbar-count');

                    var updateModelValue = function(_val) {
                        scope.count = _val.length;
                        if (scope.count >= scope.MAX + 1) {
                            ngModel.$$parentForm.$setValidity('maxlength', false);
                            $editor.addClass('border-error');
                            $counterButton.addClass('redactor-toolbar-count--error');
                        } else {
                            ngModel.$$parentForm.$setValidity('maxlength', true);
                            $editor.removeClass('border-error');
                            $counterButton.removeClass('redactor-toolbar-count--error');
                        }
                        ngModel.$setViewValue(_val);
                        ngModel.$render();
                    };
                    if (val) {
                        updateModelValue(val);
                    } else if (scope.fallbackTextValue !== undefined) {
                        updateModelValue(scope.fallbackTextValue);
                    } else {
                        scope.count = 0;
                        ngModel.$setViewValue('<p>&nbsp;</p>');
                        ngModel.$render();
                    }

                    $counterButton.find('.redactor-toolbar-count__count').text(scope.count);
                }

                ngModel.$formatters.push((value) => {
                    value = value == null ? '' : value;
                    scope.count = value.length;
                    $timeout(() => {
                        if (value) {
                            scope.initialLoad = true;
                        }
                        el.redactor('code.set', value);
                    });
                });

                if (!$window.RedactorPlugins) {
                    $window.RedactorPlugins = {};
                }

                $window.RedactorPlugins.addimage = () => {
                    return {
                        // eslint-disable-next-line object-shorthand
                        init() {
                            const imageButton = this.button.add('image', 'Image');
                            this.button.setIcon(imageButton, '<i class="material-icons md-18">image</i>');
                            this.button.addCallback(imageButton, this.addimage.show);
                        },
                        show() {
                            this.selection.save();
                            let state = $state.current.name.split('.')[0];
                            imageLibraryService.open({
                                multiSelect: false,
                                context: state,
                                associationTags: [state]
                            }).then((data) => {
                                $timeout(() => {
                                    let val = `<span><img src="${data.fullUri}"></span>`;
                                    this.selection.restore();
                                    el.redactor('insert.raw', val);
                                });
                            });
                        }
                    };
                };

                $window.RedactorPlugins.addvideo = () => {
                    return {
                        // eslint-disable-next-line object-shorthand
                        init() {
                            const videoButton = this.button.add('video', 'Video');
                            this.button.setIcon(videoButton, '<i class="material-icons md-18">videocam</i>');
                            this.button.addCallback(videoButton, this.addvideo.show);
                        },
                        show() {
                            this.selection.save();
                            $mdDialog.show({
                                clickOutsideToClose: true,
                                template: '<redactor-embed-video-modal></redactor-embed-video-modal>'
                            }).then((data) => {
                                $timeout(() => {
                                    let utubeId;
                                    let splitChar = (/youtube\.com/.test(data.youtube)) ? 'v=' : 'e/';
                                    utubeId = data.youtube.substr(data.youtube.indexOf(splitChar) + 2);
                                    let width = data.fullWidth ? '100%' : `${data.width}px`;
                                    let height = `${data.height}px`;
                                    let iframeHtml = `<iframe
                                    src="https://www.youtube.com/embed/${utubeId}"
                                    style="max-width: 100%;"
                                    id="vln-pages-video"
                                    width="${width}"
                                    height="${height}"
                                    frameborder="0" allowfullscreen></iframe>`;
                                    this.selection.restore();
                                    el.redactor('insert.raw', iframeHtml);
                                });
                            });
                        }
                    };
                };

                $window.RedactorPlugins.addlink = () => {
                    return {
                        // eslint-disable-next-line object-shorthand
                        init() {
                            const linkButton = this.button.add('link', 'Link');
                            this.button.setIcon(linkButton, '<i class="material-icons md-18">insert_link</i>');
                            this.button.addCallback(linkButton, this.addlink.show);
                        },
                        show() {
                            this.selection.save();
                            return menuEditorService.openAddToMenuDialog(undefined, 'body')
                                .then((data) => {
                                    $timeout(() => {
                                        let url = '';

                                        if (data.itemType === 'link') {
                                            url = data.newItem.url || '';
                                        } else if (data.itemType === 'category') {
                                            url = `/c/${data.newItem.seo.friendlyName}`;
                                        } else if (data.itemType === 'product') {
                                            url = `/p/${data.newItem.seo.friendlyName}`;
                                        } else if (data.itemType === 'page') {
                                            url = `/page/${data.newItem.seo.friendlyName}`;
                                        }

                                        this.selection.restore();
                                        el.redactor('insert.raw', `<a href="${url}">${data.newItem.name || url}</a>`);
                                    });
                                });
                        }
                    };
                };

                $window.RedactorPlugins.bufferbuttons = function() {
                    return {
                        // eslint-disable-next-line object-shorthand
                        init: function() {
                            const undo = this.button.add('undo', 'Undo');
                            this.button.setIcon(undo, '<i class="material-icons md-18">undo</i>');
                            const redo = this.button.addAfter('undo', 'redo', 'Redo');
                            this.button.setIcon(redo, '<i class="material-icons md-18">redo</i>');

                            this.button.addCallback(undo, this.buffer.undo);
                            this.button.addCallback(redo, this.buffer.redo);
                        }
                    };
                };

                $window.RedactorPlugins.charactercounter = () => {
                    return {
                        init() {
                            const counterDisplay = this.button.add('counter', 'Character Counter');
                            this.button.setIcon(
                                counterDisplay,
                                `<span class="redactor-toolbar-count">
                                    <span class="redactor-toolbar-count__count">${scope.count}</span>
                                    / ${scope.MAX}
                                </span>`
                            );
                            this.button.addCallback(counterDisplay, this.charactercounter.noop);
                        },
                        noop() {}
                    };
                };

                $window.RedactorPlugins.expand = () => {
                    return {
                        init() {
                            const expand = this.button.add('expand', 'Expand');
                            this.button.setIcon(expand, '<i class="material-icons md-18">zoom_out_map</i>');
                            this.button.addCallback(expand, this.expand.toggle);
                        },
                        toggle() {
                            angular.element('.page__content').toggleClass('page__content--expanded');
                        }
                    };
                };
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/redactor/redactor.directive.js